import styled from 'styled-components';

import { background_02_7x2_a } from '@xing-com/background-images';
import { Button, TextButton } from '@xing-com/button';
import { Tag } from '@xing-com/tag';
import {
  cornerRadius3XL,
  cornerRadiusXL,
  dropShadowS,
  spaceL,
  spaceS,
  spaceXL,
  xdlColorBackground,
  xdlColorBorderSoft,
  xdlColorControlBorderSecondary,
  xdlColorIllustrationBackground,
  xdlColorTextOnLight,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const Container = styled.div`
  background-color: ${xdlColorBackground};
  background-image: url(${background_02_7x2_a});
  background-position: center;
  border-radius: ${cornerRadius3XL};
  padding: ${spaceXL};
  border: 1px solid ${xdlColorBorderSoft};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: ${dropShadowS};
  height: 100%;
  max-width: 342px;
  justify-content: center;
`;

export const Title = styled(Headline)`
  color: ${xdlColorTextOnLight};
`;

export const Description = styled(BodyCopy)`
  color: ${xdlColorTextOnLight};
  max-width: 300px;
  margin-bottom: ${spaceXL};
  margin-top: ${spaceS};
`;

export const TagList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
  align-items: center;
`;

export const TagItem = styled(Tag)`
  color: ${xdlColorTextOnLight};
  background-color: ${xdlColorIllustrationBackground};
  border-color: ${xdlColorControlBorderSecondary};
  border-radius: ${cornerRadiusXL};
  padding: ${spaceL} ${spaceS};
  width: fit-content;
  &:after {
    background-color: ${xdlColorIllustrationBackground};
    border-color: ${xdlColorControlBorderSecondary};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceL};
  padding-top: ${spaceXL};
`;

export const StyledButton = styled(Button)`
  border-radius: ${cornerRadius3XL};
  border-color: ${xdlColorTextOnLight};
  background-color: transparent;
  color: ${xdlColorTextOnLight};
  &:after {
    border-color: ${xdlColorTextOnLight};
  }
  &:hover {
    &:after {
      border-color: ${xdlColorTextOnLight};
    }
  }
`;

export const StyledTextButton = styled(TextButton)`
  color: ${xdlColorTextOnLight};
  &:visited {
    color: ${xdlColorTextOnLight};
  }
`;
